export const Title = ({
  title,
  subtitle,
}: {
  title: string;
  subtitle?: string;
}) => {
  return (
    <div className="flex w-full flex-col items-start text-left">
      <h2 className="font-sentient text-2xl font-medium text-secondary sm:text-3xl md:text-4xl lg:text-5xl">
        {title}
      </h2>
      {subtitle && (
        <p className="font-satoshi text-base text-accent lg:text-lg">
          {subtitle}
        </p>
      )}
    </div>
  );
};
